import { BaseCell } from '../../models';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from 'src/app/services/settings.service';

@Injectable({ providedIn: 'root' })
export abstract class CellParserBase {
  constructor(
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private percentPipe: PercentPipe,
    private translateService: TranslateService,
    private settingsService: SettingsService
  ) {}

  abstract parse<T extends BaseCell>(cell: T): CardListCell;

  protected getSeparator(cell: BaseCell): string {
    return cell.separator ? cell.separator : ' ';
  }

    protected getFooterResolver(cell: BaseCell) {
        return (response: { [x: string]: any }) => {
            console.log(response);
            //   let cellValue = this.getPropertyValue(cell.footer, response);
            var sum = response.reduce((sum, current) => sum + current[cell.footer], 0);
            return this.decimalPipe.transform(sum, '1.2-2');        
        }
    }

  protected getTextResolver(cell: BaseCell) {
    if (cell.overrideText) return () => '';

    let separator = this.getSeparator(cell);
    if (cell.propertyNames) {
      return (response: { [x: string]: any }) => {
        let cellValue = cell.propertyNames.map((propertyName) => this.getPropertyValue(propertyName, response)).join(separator);

        if (cell.dataType) {  
          if (cell.dataType === 'Percent')   {
            cellValue = this.percentPipe.transform(cellValue, '1.2-5') ;  
          } 
          if (cell.dataType === 'Decimal')   {
            let format = cell.format ? cell.format :'1.2-2';       
            if(cell.propertyNames.length == 2) {                   
              cellValue = this.decimalPipe.transform(this.getPropertyValue(cell.propertyNames[0], response), format) + ' ' + this.getPropertyValue(cell.propertyNames[1], response);
            }
            else {
              cellValue = this.decimalPipe.transform(cellValue, format);
            }
          }
          if (cell.dataType === 'Date')   {
             cellValue = this.datePipe.transform(cellValue, cell.format);
          }
        } else {
          if (cell.format) {  
            if (cell.format === '1.0-0' || cell.format === '1.2-2') 
              cellValue = this.decimalPipe.transform(cellValue, cell.format);
            else
               cellValue = this.datePipe.transform(cellValue, cell.format);
          }
        }

        if (cell.translate)
          cellValue = this.translateService.instant(cellValue);

        return cellValue;
      };
    } else {
      return () => '';
    }
  }

  protected getCsvResolver(cell: BaseCell) {
    if (cell.overrideText) return () => '';

    let csvFormat = this.settingsService.getCsvFormat();
  
    let decmialSeparator = csvFormat[1];
    let csvFieldSeparator = csvFormat[0];
    let separator = this.getSeparator(cell);
    if (cell.propertyNames) {
      return (response: { [x: string]: any }) => {

        let cellValue = cell.propertyNames
          .map((propertyName) => this.getPropertyValue(propertyName, response))
          .join(separator);
          
        if (cell.dataType) {  
          if (cell.dataType === 'Percent')   {
            cellValue = this.percentPipe.transform(cellValue, '1.2-5').replace(/,/g,'').replace('.',',');
          } 
          if (cell.dataType === 'Decimal')   {           
            if(cell.propertyNames.length == 2) {                                    
              cellValue = this.getPropertyValue(cell.propertyNames[0], response).toFixed(2).replace('.', decmialSeparator) + csvFieldSeparator + this.getPropertyValue(cell.propertyNames[1], response);
            }
            else {
              cellValue = this.getPropertyValue(cell.propertyNames[0], response).toFixed(2).replace('.', decmialSeparator);
            }      
          }
          if (cell.dataType === 'Date')   {
             cellValue = this.datePipe.transform(cellValue, cell.format);
          }
        }

        if (cell.translate)
          cellValue = this.translateService.instant(cellValue);

        return cellValue;
      };
    } else {
      return () => '';
    }
  }
  protected propertyExistsInResponse(propertyName: string, response: any) {
    return propertyName in response;
  }

  protected getPropertyValue(propertyName: string, response: any) {

    if(propertyName.startsWith("'")) return propertyName.replace(/'/g, '');
    if (this.propertyExistsInResponse(propertyName, response) === false) {
      console.warn(
        `Property name ${propertyName} does not exist in response: ${JSON.stringify(
          response
        )}`
      );
      return '';
    } else return response[propertyName];
  }
}
